'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
    var resolver = this;

    if (catcher === true) {
        if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
            var _tasks = [];

            if (!tick) {
                try {
                    tick = process.nextTick;
                } catch (ex) {
                    tick = function tick(p) {
                        setTimeout(p, 0);
                    };
                }
            }

            function _untask() {
                for (var i = 0; i < _tasks.length; i += 2) {
                    var t = _tasks[i + 1],
                        r = _tasks[i];

                    for (var j = 0; j < t.length; j++) {
                        t[j].call(null, r);
                    }
                }

                _tasks = [];
            }

            function isThenable(obj) {
                return obj && obj instanceof Object && typeof obj.then === 'function';
            }

            function EagerThenable(resolver) {
                function done(inline) {
                    var w;
                    if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

                    _tasks.push(result, w);

                    _thens = [[], []];
                    if (_tasks.length === 2) inline ? _untask() : tick(_untask);
                }

                function resolveThen(x) {
                    if (isThenable(x)) return x.then(resolveThen, rejectThen);
                    phase = 0;
                    result = x;
                    done(true);
                }

                function rejectThen(x) {
                    if (isThenable(x)) return x.then(resolveThen, rejectThen);
                    phase = 1;
                    result = x;
                    done(true);
                }

                function settler(resolver, rejecter) {
                    _thens[0].push(resolver);

                    _thens[1].push(rejecter);

                    done();
                }

                function toString() {
                    return 'EagerThenable{' + {
                        '-1': 'pending',
                        0: 'resolved',
                        1: 'rejected'
                    }[phase] + '}=' + result.toString();
                }

                this.then = settler;
                this.toString = toString;
                var _thens = [[], []],
                    _sync = true,
                    phase = -1,
                    result;
                resolver.call(null, resolveThen, rejectThen);
                _sync = false;
                done();
            }

            EagerThenable.resolve = function (v) {
                return isThenable(v) ? v : {
                    then: function then(resolve, reject) {
                        return resolve(v);
                    }
                };
            };

            return EagerThenable;
        }();
        return new Function.prototype.$asyncbind.EagerThenable(boundThen);
    }

    if (catcher) {
        if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
        return then;
    }

    function then(result, error) {
        try {
            return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
        } catch (ex) {
            return (error || catcher)(ex);
        }
    }

    function boundThen(result, error) {
        return resolver.call(self, result, error);
    }

    boundThen.then = boundThen;
    return boundThen;
};

/**
 * fetch 请求
 * @param url 请求的url
 * @param param 请求的参数
 * @param success 请求成功的回调
 * @param error 请求失败的回调
 * @param options 请求的其他配置参数
 */
function ajax(url, param, success, error, options) {
    var _options = _lodashCompat2.default.assign({}, options);
    if (!options) {
        options = {};
    }
    _options.method = options.method && options.method.toLocaleUpperCase() == 'GET' ? "GET" : "POST";
    if (!_options.headers) {
        _options.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
    } else {
        !_options.headers['Accept'] && (_options.headers['Accept'] = 'application/json');
        !_options.headers['Content-Type'] && (_options.headers['Content-Type'] = 'application/json');
    }
    _options.headers['X-Requested-With'] = "XMLHttpRequest";
    if (!_lodashCompat2.default.isEmpty(param)) {
        try {
            _options.body = JSON.stringify(param);
        } catch (e) {
            console.error('JSON stringify error', param);
        }
    }
    !options['credentials'] && (_options['credentials'] = 'same-origin');
    fetch(url, _options).then(function (_res) {
        if (_res.ok) {
            _res.json().then(function (res) {
                if (res.hasOwnProperty('status')) {
                    if (res.status == "1") {
                        if (success) {
                            success(res.data);
                        }
                    } else if (res.status == "0" || res.status == '401') {
                        if (error) {
                            error(res.status == '401' ? Object.assign({}, res.data, { errorCode: 401 }) : res.data);
                            console.error("AJAX 返回 status 为 " + res.status, res);
                        }
                    }
                } else {
                    if (success) {
                        success(res.data);
                    }
                }
            });
        } else {
            // TODO: 需要做处理
            console.error("Looks like the response wasn't perfect, got status", _res.status);
        }
    }, function (res) {
        if (error) {
            try {
                var data = JSON.parse(res.responseText).data;
            } catch (e) {}
            if (data && data.errorCode && data.message) {
                error(data);
            } else {
                error({ message: "未知错误！" });
            }
        } else {
            console.error("AJAX 错误", res);
        }
    });
}

//function ApiError({ message, errorCode, ...data }) {
//    this.name = 'ApiError';
//    this.message = message;
//    this.errorCode = errorCode;
//    this.data = data;
//    this.stack = (new Error()).stack;
//}
//ApiError.prototype = Object.create(Error.prototype);
//ApiError.prototype.constructor = ApiError;

exports.default = ajax;